import * as React from "react";

import { cn } from "@/lib/utils";
import { MessageError } from "../common";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea"> & {
    isInvalid?: boolean | string | null;
    isValid?: boolean | string | null;
    messageError?: string;
    showError?: boolean;
  }
>(
  (
    { className, isInvalid, isValid, messageError, showError = true, ...props },
    ref
  ) => {
    return (
      <div className="space-y-1">
        <textarea
          className={cn(
            "flex min-h-[80px] w-full resize-none rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500/35 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            className,
            {
              "is-invalid": isInvalid,
            },
            {
              "is-valid": isValid,
            }
          )}
          ref={ref}
          {...props}
        />
        {showError && <MessageError messageError={messageError} />}
      </div>
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
